import { render } from "./CASIInput.vue?vue&type=template&id=a6b1fbc4&scoped=true"
import script from "./CASIInput.vue?vue&type=script&lang=js"
export * from "./CASIInput.vue?vue&type=script&lang=js"

import "./CASIInput.vue?vue&type=style&index=0&id=a6b1fbc4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6b1fbc4"]])

export default __exports__